import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { SelectBase } from '@/components/ui/Form/SelectBase';
import { tailwindConfig } from '@/style/config';
const { theme } = tailwindConfig;
export const Select = (props) => {
    const { className = '', components, defaultValue, disabled = false, ellipsis = true, id = undefined, inputRef = undefined, isError = false, menuIsOpen = undefined, name = undefined, onBlur, onChange: propOnChange, onFocus, options, placeholder = '', value: propValue = undefined, } = props;
    const getBorderColor = useCallback((isFocused) => {
        if (disabled) {
            return theme.colors.gray['300'];
        }
        if (isError) {
            return theme.colors.red['100'];
        }
        return isFocused ? theme.colors.navy['100'] : theme.colors.gray['300'];
    }, [disabled, isError]);
    const styles = useMemo(() => ({
        control: (provided, state) => (Object.assign(Object.assign({}, provided), { ':hover': !disabled && !isError
                ? {
                    borderColor: theme.colors.navy['100'],
                }
                : {}, backgroundColor: disabled
                ? theme.colors.gray['75']
                : theme.colors.gray['50'], borderColor: getBorderColor(state.isFocused), boxShadow: 'none', color: theme.colors.gray['600'], minHeight: 40, width: '100%' })),
        dropdownIndicator: (provided) => (Object.assign(Object.assign({}, provided), { color: theme.colors.gray['600'] })),
        indicatorSeparator: (provided) => (Object.assign(Object.assign({}, provided), { display: 'none' })),
        option: (provided, state) => (Object.assign(Object.assign({}, provided), { ':active': {
                background: theme.colors.gray['75'],
            }, background: state.isSelected || state.isFocused
                ? theme.colors.gray['75']
                : theme.colors.gray['50'], color: theme.colors.gray['600'], fontSize: theme.fontSize['13'], padding: theme.spacing['8'] })),
        placeholder: (provided) => (Object.assign(Object.assign({}, provided), { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' })),
        singleValue: (provided) => !ellipsis
            ? Object.assign(Object.assign({}, provided), { textOverflow: 'clip', whiteSpace: 'normal', width: '100%' }) : provided,
        valueContainer: (provided) => (Object.assign(Object.assign({}, provided), { padding: theme.spacing['8'] })),
    }), [disabled, ellipsis, isError, getBorderColor]);
    const onChange = (newValue) => {
        var _a;
        propOnChange((_a = newValue === null || newValue === void 0 ? void 0 : newValue.value) !== null && _a !== void 0 ? _a : null);
    };
    const value = useMemo(() => options.find((option) => option.value === propValue) || null, [options, propValue]);
    return (_jsx(SelectBase, { className: className, components: components, defaultValue: defaultValue, id: id, isDisabled: disabled, isSearchable: false, menuIsOpen: menuIsOpen, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, options: options, placeholder: placeholder, ref: inputRef, styles: styles, value: value }));
};
